'use strict'

module.exports = self => require('./add')(self)
